<div className="updateProgressSuccess">
  <div class="hug-tutor-modal-body">
    <div class="hug-graphic-success mb-8">
      <img
        class="hug-graphic-success__bg"
        src="assets/images/tutor/hug-bg-success.svg"
        alt="HUG success background"
      />
      <img
        class="hug-graphic-success__starMain animate__animated animate__tada animate__infinite animate__slower"
        src="assets/images/tutor/hug-icon-star.svg"
        alt="HUG success star main"
      />
      <img
        class="hug-graphic-success__starSub1 animate__animated animate__tada animate__infinite animate__slow"
        src="assets/images/tutor/hug-icon-star.svg"
        alt="HUG success star sub1"
      />
      <img
        class="hug-graphic-success__starSub2 animate__animated animate__tada animate__infinite animate__slow"
        src="assets/images/tutor/hug-icon-star.svg"
        alt="HUG success star sub2"
      />
    </div>
    <h3 class="hug-h3 text-center mb-2">Feedback</h3>
    <p class="text-center mb-5">Please contact your H.U.G. online specialist and provide your comments on the tutor experience </p>

    <div class="text-center" style="margin-top: 1rem">
      <button
        class="hug-btn hug-btn--primary"
        mat-button
        color="primary"
        (click)="confirmAction()"
      >
        Ok
      </button>
    </div>
  </div>
</div>
